import React from 'react';
import { Box, Flex, Heading, Button } from '@chakra-ui/react';
import Icon from './Icon';

// White surface card with an optional header (icon + title + right-aligned
// action) and a body. The workhorse container for dashboard panels and the
// tables on the admin pages. Matches the marketing card treatment: gray.200
// border, radius xl, subtle shadow.
const Panel = ({
  title,
  icon,
  actionLabel,
  onAction,
  action,
  children,
  bodyProps,
  headerProps,
  ...props
}) => {
  const hasHeader = title || actionLabel || action || icon;

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="xl"
      boxShadow="sm"
      overflow="hidden"
      display="flex"
      flexDirection="column"
      {...props}
    >
      {hasHeader && (
        <Flex
          align="center"
          justify="space-between"
          gap={3}
          px={6}
          py={4}
          borderBottom="1px solid"
          borderColor="gray.100"
          {...headerProps}
        >
          <Flex align="center" gap={2} minW={0}>
            {icon && (
              <Icon
                name={icon}
                style={{ fontSize: '20px', color: 'var(--color-primary-maroon)' }}
              />
            )}
            {title && (
              <Heading size="md" noOfLines={1} color="gray.900">
                {title}
              </Heading>
            )}
          </Flex>
          {action ||
            (actionLabel && onAction && (
              <Button
                variant="link"
                size="sm"
                onClick={onAction}
                flexShrink={0}
                rightIcon={<Icon name="chevron_right" style={{ fontSize: '16px' }} />}
              >
                {actionLabel}
              </Button>
            ))}
        </Flex>
      )}
      <Box px={6} py={5} flex="1" {...bodyProps}>
        {children}
      </Box>
    </Box>
  );
};

export default Panel;
